import {
  Box,
  IconButton,
  Input,
  List,
  ListItemButton,
  Tooltip,
} from "@mui/joy";
import { ClickAwayListener, Typography } from "@mui/material";
import { ReactElement, useState } from "react";
import { useSections } from "../../redux/section/sectionHooks";

/**
 *
 * @param root0
 * @param root0.onSelect
 * @param root0.children
 * @returns {ReactElement} sectionTooltip page
 */
export function SectionTooltip({
  onSelect,
  children,
}: {
  onSelect: (i: number | null) => void;
  children: ReactElement;
}) {
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const { sections } = useSections();

  let list = sections;
  if (searchText)
    list = list.filter((e) =>
      e.name.toLowerCase().includes(searchText.toLowerCase())
    );
  return (
    <Tooltip
      arrow
      open={open}
      color="neutral"
      variant="outlined"
      title={
        <ClickAwayListener
          onClickAway={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setOpen(false);
          }}
        >
          <Box
            sx={{
              width: 400,
              maxHeight: 400,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box sx={{ p: 1 }}>
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                startDecorator={
                  <i className="fa-solid fa-magnifying-glass"></i>
                }
                variant="soft"
                size="sm"
                autoFocus
                placeholder="Search"
                endDecorator={
                  <IconButton
                    tabIndex={-1}
                    onClick={() => setSearchText("")}
                    variant="plain"
                    color="neutral"
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </IconButton>
                }
              />
            </Box>
            <List size="sm">
              {list.map((sr) => (
                <ListItemButton
                  onClick={(e) => {
                    onSelect(sr.id);
                    setOpen(false);
                  }}
                  key={sr.id}
                >
                  {sr.name}
                </ListItemButton>
              ))}
            </List>
          </Box>
        </ClickAwayListener>
      }
    >
      <Box sx={{ display: "inline-block" }} onClick={() => setOpen(true)}>
        {children}
      </Box>
    </Tooltip>
  );
}
